var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-button',{attrs:{"color":"primary","to":"/add-a-site","size":"sm"}},[_vm._v(" + "),_c('span',{staticClass:"c-sidebar-brand-full"},[_vm._v("Add a Site")])])}
var staticRenderFns = []

export { render, staticRenderFns }